import { createContext, useState } from 'react';
import api from 'services/api';

const filter = {
  like: '',
  id: '',
  motivo: '',
  ativo: null,
};

export const CrmMotivoDescarteContext = createContext();

export const CrmMotivoDescarteProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [crmMotivoDescarte, setCrmMotivoDescarte] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getCrmMotivoDescarte = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: crmMotivoDescarte?.filter,
        page: crmMotivoDescarte?.page,
        size: crmMotivoDescarte?.size,
        order: crmMotivoDescarte?.order,
        ...payload,
      });
      setCrmMotivoDescarte((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <CrmMotivoDescarteContext.Provider
      value={{
        getLoading,
        crmMotivoDescarte,
        getCrmMotivoDescarte,
      }}
    >
      {children}
    </CrmMotivoDescarteContext.Provider>
  );
};
